import { ShareTypeCode } from "@/common/share";
import { Portfolio } from "@/common/common";
import { HttpEvent, HttpEventCallbacks, httpGet, httpPut } from "@/events/eventsDomain";

type NewCompanyRequest = {
  country: string;
  entityTypeCode: string;
  identifier: string;
  subdivision: string | null;
  name: string;
  tinNumber: string | null;
};

type AddCompanyRequest = {
  subscriptionType: string | null;
  completeOnboarding: boolean;
  adminUserIds: string[];
  portfolioId: string | null;
  newCompany: NewCompanyRequest;
  parent: ParentOwnershipRequest | null;
};

export type ParentOwnershipRequest = {
  orgNo: string;
  ownership: ParentOwnershipTerms;
  registeredAt: string;
};

export type ParentOwnershipTerms =
  | { type: "percent"; percentHeld: string }
  | { type: "shares"; holdings: ParentShareClassHolding[] };

export type ParentShareClassHolding = {
  shareTypeCode: ShareTypeCode;
  held: number;
  total: number;
};

type AddCompaniesResponse = {
  numberOfAddedCompanies: number;
  notFound: string[];
};

type NewCompanyRejectionCode =
  | "UNKNOWN_COUNTRY"
  | "UNKNOWN_ENTITY_TYPE"
  | "ENTITY_TYPE_BLOCKED"
  | "INVALID_IDENTIFIER"
  | "SUBDIVISION_REQUIRED"
  | "INVALID_SUBDIVISION"
  | "NAME_REQUIRED"
  | "PARENT_NOT_IN_ACCOUNT"
  | "INVALID_PARENT_OWNERSHIP"
  | "ALREADY_EXISTS"
  | "IN_ANOTHER_ACCOUNT"
  | "NOT_OWNERSHIP_REGISTER";

export type NewCompanyRejection = {
  code: NewCompanyRejectionCode;
  expectedExample: string | null;
  organisationNumber: string | null;
};

export type EnterpriseAccountApiClient = {
  getPortfolios: (
    accountId: string,
    params: HttpEventCallbacks<Portfolio[]>,
  ) => HttpEvent<Portfolio[]>;
  addCompany: (
    accountId: string,
    request: AddCompanyRequest,
    params: HttpEventCallbacks<AddCompaniesResponse>,
  ) => HttpEvent<AddCompaniesResponse>;
};

export const enterpriseAccountApiClient: EnterpriseAccountApiClient = {
  getPortfolios: (accountId, params) =>
    httpGet({ url: `/enterprise-accounts/${encodeURIComponent(accountId)}/portfolios`, ...params }),
  addCompany: (accountId, request, params) =>
    httpPut({
      url: `/enterprise-accounts/${encodeURIComponent(accountId)}/company`,
      data: request,
      ...params,
    }),
};
